import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthNewContext";
import { useStock } from "../../context/StockContext";
import { useWatchlist } from "../../context/WatchlistContext";
import { RiDeleteBin7Line } from "react-icons/ri";
import { useSecurityMaster } from "../../context/SecurityMasterContext";
import { useMarketIndicators } from "../../context/MarketIndicatorContext";
import { useNotification } from "../../context/NotificationContext";
import { usePrediction } from "../../context/PredictionContext";
import { FaBell, FaBellSlash } from "react-icons/fa";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { FiRefreshCw } from "react-icons/fi";
import { useMarket } from "../../context/MarketDhanContext";
import { FaEdit } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import "./WatchList.css";
import { FaNeos } from "react-icons/fa6";
import { useMarketSnapshot } from "../../context/MarketSnapshotContext";
import { useTechnicalSnapshot } from "../../context/TechnicalSnapshotContext";
import useLocalSearch from "../../hooks/useLocalSearch";
import useLivePrices from "../../hooks/useLivePrices";

// const WatchlList = () => {
//   const { results, searchLoading, searchError, searchStocks } = useStock();
//   const { fetchWatchlist, addToWatchlist, removeFromWatchlist } =
//     useWatchlist();
//   const stockList = [
//     { id: 1, stock_name: "SBILIFE", percent_change: "4.2" },
//     { stock_name: "TCS", percent_change: "4" },
//     { stock_name: "INFY", percent_change: "3.8" },
//   ];
//   const navigate = useNavigate();
//   const user = useAuth();
//   const finalUser = user?.user;
//   console.log("User", finalUser);

//   const { getSecurityIds } = useSecurityMaster();

//   const handleAdd = async (symbol) => {
//     try {
//       const res = await getSecurityIds([symbol]);

//       const securityId = res?.[0]?.security_id;

//       await addToWatchlist({
//         userID: user.userID,
//         symbol,
//         securityId,
//       });
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   return (
//     <>
//       {/* <div className="back-btn">
//         <button className="rec-btn" onClick={() => navigate(-1)}>
//           Back
//         </button>
//       </div>
//       <div className="stock-table-container">
//         <table className="stock-table">
//           <thead>
//             <tr>
//               <th>Company</th>
//               <th>Remove</th>

//               <th>Recommendation</th>
//             </tr>
//           </thead>
//           <tbody>
//             {stockList.map((item, id) => (
//               <>
//                 <tr key={id}>
//                   <td>{item.stock_name}</td>
//                   <td>
//                     <button
//                       className="rec-btn"

//                     >
//                       Remove
//                     </button>
//                   </td>
//                   <td>
//                     <button
//                       className="rec-btn"
//                       onClick={() =>
//                         navigate(`/stockdetail/${item.stock_name}`)
//                       }
//                     >
//                       Recommendation
//                     </button>
//                   </td>
//                 </tr>
//               </>
//             ))}
//           </tbody>
//         </table>
//       </div> */}
//     </>
//   );
// };

const WatchList = () => {
  const navigate = useNavigate();

  /* ================= CONTEXT ================= */
  const { results, searchLoading, searchStocks, clearResults } = useStock();
  const {
    fetchCombinedPredictions,
    combinedPredictionMap,
    combinedLastUpdated,
    combinedIntradayUpdated,
  } = usePrediction();
  const {
    query: localSearch,
    setQuery: setLocalSearch,
    equityResults: localEquityResults,
    loading: localSearchLoading,
    clearResults: clearLocalResults,
  } = useLocalSearch();
  const {
    prices: livePrices,
    isLive,
    subscribeSymbols,
    lastTickTime,
  } = useLivePrices();
  const {
    marketSnapshot,
    marketLoading,
    marketError,
    getMarketSnapshot,
    resetMarketSnapshot,
  } = useMarketSnapshot();

  const { getTechnicalSnapshot, technicalSnapshot } = useTechnicalSnapshot();
  const {
    getSecurityIdBySymbol,
    securityIdData,
    securityError,
    securityLoading,
  } = useMarket();
  const {
    watchlist,
    fetchWatchlist,
    addToWatchlist,
    removeFromWatchlist,
    resetWatchlist,
    isInWatchlist,
    toggleNotification,
    updatePotentialUpside,
    updatePrices,
  } = useWatchlist();
  const [snapshotMap, setSnapshotMap] = useState({});
  const [snapshotLoading, setSnapshotLoading] = useState(false);
  const [percentSort, setPercentSort] = useState("none");
  const [volumeSort, setVolumeSort] = useState("none");

  const { getSecurityIds } = useSecurityMaster();
  const [isEnabled, setIsEnabled] = useState(false);
  const [tempUpside, setTempUpside] = useState({});
  const [notificationMap, setNotificationMap] = useState({});
  const [activeBell, setActiveBell] = useState(null);
  const [lastUpdate, setLastUpdate] = useState("");
  const { getBulkQuotes, bulkError, bulkLoading, bulkQuotes, resetBulkQuotes } =
    useMarketIndicators();
  const {
    processSignalNotifications,
    notificationLoading,
    notificationError,
    notificationData,
  } = useNotification();
  const { user } = useAuth();
  const location = useLocation();
  const [editUpside, setEditUpside] = useState({});
  const [editPrice, setEditPrice] = useState({});
  const [tempPrice, setTempPrice] = useState({});

  const userID = user?.userID;

  const [searchText, setSearchText] = useState("");

  // useEffect(() => {
  //   if (!userID) {
  //     resetWatchlist();
  //     resetBulkQuotes();
  //   }

  //   fetchWatchlist(userID);
  // }, [userID]);

  // useEffect(() => {
  //   if (!userID) return;

  //   const loadData = async () => {
  //     resetWatchlist();
  //     resetBulkQuotes();

  //     const wl = await fetchWatchlist(userID); // 👈 MUST return data

  //     if (!wl?.length) return;

  //     const ids = wl
  //       .map((item) => item.securityId)
  //       .filter(Boolean)
  //       .map(Number)
  //       .filter((id) => !isNaN(id));

  //     if (ids.length) {
  //       await getBulkQuotes(ids); // 🔥 guaranteed call
  //     }
  //   };

  //   loadData();
  // }, [userID]);
  // const toggleNotification = (symbol) => {
  //   setNotificationMap((prev) => ({
  //     ...prev,
  //     [symbol]: !prev[symbol],
  //   }));
  // };
  useEffect(() => {
    if (!userID) {
      resetWatchlist();
      return;
    }

    fetchWatchlist(userID);
  }, [userID]);
  //websocket
  //   useEffect(() => {
  //   if (!watchlist?.length) return;

  //   const symbols = [
  //     ...new Set(
  //       watchlist
  //         .map((item) =>
  //           String(item?.symbol || "")
  //             .trim()
  //             .toUpperCase(),
  //         )
  //         .filter(Boolean),
  //     ),
  //   ];

  //   if (!symbols.length) return;

  //   subscribeSymbols(symbols);
  // }, [watchlist, subscribeSymbols]);
  // useEffect(() => {
  //   if (!watchlist?.length) return;

  //   const symbols = watchlist.map((item) => item?.symbol).filter(Boolean);

  //   subscribeSymbols(symbols);
  // }, [watchlist]);
  const symbolListKey = useMemo(
    () =>
      watchlist
        .map((w) => w?.symbol)
        .filter(Boolean)
        .sort()
        .join(","),
    [watchlist],
  );

  useEffect(() => {
    if (!symbolListKey) return;
    const symbols = symbolListKey.split(",");
    subscribeSymbols(symbols);
  }, [symbolListKey]);
  // useEffect(() => {
  //   if (!watchlist?.length) {
  //     setSnapshotMap({});
  //     return;
  //   }

  //   const loadMarketSnapshots = async () => {
  //     try {
  //       setSnapshotLoading(true);

  //       const entries = await Promise.all(
  //         watchlist.map(async (item) => {
  //           const data = await getMarketSnapshot(item.symbol);
  //           return [item.symbol, data];
  //         }),
  //       );

  //       setSnapshotMap(Object.fromEntries(entries));
  //     } catch (err) {
  //       console.error("Market snapshot load failed:", err);
  //     } finally {
  //       setSnapshotLoading(false);
  //     }
  //   };

  //   loadMarketSnapshots();
  // }, [watchlist]);
  /* ================= SEARCH ================= */
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     if (searchText?.length >= 2) {
  //       searchStocks(searchText);
  //     }
  //   }, 300);

  //   return () => clearTimeout(timer);
  // }, [searchText]);

  // useEffect(() => {
  //   if (!watchlist?.length) return;

  //   const ids = watchlist
  //     .map((item) => item.securityId)
  //     .filter(Boolean)
  //     .map(Number)
  //     .filter((id) => !isNaN(id));

  //   if (!ids.length) return;

  //   getBulkQuotes(ids);
  // }, [watchlist]);

  // const handleAdd = async (symbol) => {
  //   try {
  //     const res = await getSecurityIds([symbol]);
  //     const securityId = res?.[0]?.security_id;

  //     await addToWatchlist({
  //       userID,
  //       symbol,
  //       securityId,
  //     });

  //     setSearchText("");
  //     clearResults();
  //     // clear input
  //   } catch (err) {
  //     console.error("Add failed:", err);
  //   }
  // };
  const filteredLocalStockResults = localEquityResults || [];

  //previosu working code
  // const handleAdd = async (symbol) => {
  //   try {
  //     // const res = await getSecurityIds([symbol]);
  //     // const securityId = res?.[0]?.security_id;
  //     const res = await getSecurityIdBySymbol(symbol);

  //     const securityId = res?.security_id;

  //     if (!securityId) {
  //       console.error("Security ID not found");
  //       return;
  //     }

  //     await addToWatchlist({
  //       userID,
  //       symbol,
  //       securityId,
  //     });

  //     // ✅ Immediately fetch latest watchlist
  //     const updatedWatchlist = await fetchWatchlist(userID);

  //     const ids = updatedWatchlist
  //       .map((item) => item.securityId)
  //       .filter(Boolean)
  //       .map(Number)
  //       .filter((id) => !isNaN(id));

  //     if (ids.length) {
  //       await getBulkQuotes(ids); // 🔥 THIS FIXES YOUR ISSUE
  //     }

  //     setSearchText("");
  //     clearResults();
  //   } catch (err) {
  //     console.error("Add failed:", err);
  //   }
  // };
  // const handleAdd = async (item) => {
  //   try {
  //     if (!userID) {
  //       console.error("User not logged in");
  //       return;
  //     }

  //     const symbol = String(
  //       item?.symbol || item?.trading_symbol || item?.underlying_symbol || "",
  //     )
  //       .trim()
  //       .toUpperCase();

  //     const securityId = item?.security_id ?? item?.securityId;

  //     if (!symbol) {
  //       console.error("Symbol missing from local search result", item);
  //       return;
  //     }

  //     if (!securityId) {
  //       console.error("Security ID missing from local search result", item);
  //       return;
  //     }

  //     await addToWatchlist({
  //       userID,
  //       symbol,
  //       securityId: String(securityId),
  //     });

  //     // Reload complete rows with both snapshots
  //     await fetchWatchlist(userID);

  //     setLocalSearch("");
  //     clearLocalResults();
  //   } catch (err) {
  //     console.error("Add watchlist stock failed:", err);
  //   }
  // };
  // const handleAdd = async (item) => {
  //   try {
  //     if (!userID) return;

  //     const symbol = String(
  //       item?.symbol || item?.trading_symbol || item?.underlying_symbol || "",
  //     )
  //       .trim()
  //       .toUpperCase();

  //     const securityId = item?.security_id ?? item?.securityId;

  //     if (!symbol || !securityId) return;

  //     await addToWatchlist({
  //       userID,
  //       symbol,
  //       securityId: String(securityId),
  //     });
  //     await fetchWatchlist(userID);
  //     // DON'T call fetchWatchlist here — context already has the new row

  //     setLocalSearch("");
  //     clearLocalResults();
  //   } catch (err) {
  //     console.error("Add watchlist stock failed:", err);
  //   }
  // };
  const handleAdd = async (item) => {
    try {
      if (!userID) return;

      const symbol = String(item?.underlyingSymbol || "")
        .trim()
        .toUpperCase();
      // console.log("SYMBOL RECEIVED", symbol);

      const securityId = item?.security_id ?? item?.securityId;

      if (!symbol || !securityId) return;

      // Prevent double-add from the UI side too
      if (isInWatchlist(symbol)) return;

      // Clear search IMMEDIATELY so the dropdown closes fast
      setLocalSearch("");
      clearLocalResults();

      await addToWatchlist({
        userID,
        symbol,
        securityId: String(securityId),
      });

      // Now refetch — snapshot should be ready since backend awaits it
      await fetchWatchlist(userID);
    } catch (err) {
      console.error("Add watchlist stock failed:", err);
    }
  };
  const handleRemove = async (symbol) => {
    try {
      await removeFromWatchlist({ userID, symbol });
    } catch (err) {
      console.error("Remove failed:", err);
    }
  };
  console.log("Bulk QUotes", bulkQuotes);
  // useEffect(() => {
  //   processSignalNotifications();
  // }, []);

  // const finalData = watchlist?.map((item) => {
  //   const quote = bulkQuotes?.find(
  //     (q) => String(q.securityId) === String(item.securityId),
  //   );

  //   return {
  //     ...item,
  //     ltp: quote?.lastPrice,
  //     // change: quote?.pChange,
  //   };
  // });
  // const finalData = watchlist.map((item) => {
  //   const quote = bulkQuotes?.[item.securityId];

  //   return {
  //     ...item,
  //     ltp: quote?.last_price,
  //     change: quote?.net_change,
  //   };
  // });
  console.log("Watchlist", watchlist);
  // const finalData = watchlist.map((item) => {
  //   const id = String(item.securityId);

  //   const quote = bulkQuotes?.[id];

  //   return {
  //     ...item,
  //     ltp: quote?.last_price ?? "-",
  //     change: quote?.net_change ?? "-",
  //     ohlc: quote?.ohlc ?? "-",
  //   };
  // });
  // const finalData = watchlist.map((item) => {
  //   const snapshot = snapshotMap?.[item.symbol];
  //   const quote = snapshot?.quote?.data;
  //   const intraday = snapshot?.intraday;
  //   console.log("Snapshot", snapshot);
  //   const smart_money = snapshot?.smart_money;

  //   return {
  //     ...item,
  //     ltp: quote?.last_price ?? "-",
  //     ohlc: quote?.ohlc ?? {},
  //     intraday,
  //     percent_change:
  //       ((quote?.last_price - quote?.ohlc?.close) / quote?.ohlc?.close) * 100,
  //     quote_timestamp: snapshot?.quote_updated_at ?? null,
  //     smart_money,
  //   };
  // });
  // const finalData = watchlist.map((item) => {
  //   const snapshot = snapshotMap?.[item.symbol];
  //   const quote = snapshot?.quote?.data;
  //   const intraday = snapshot?.intraday;
  //   const smart_money = snapshot?.smart_money;

  //   const ltp = Number(quote?.last_price);
  //   const previousClose = Number(quote?.ohlc?.close);

  //   const percentChange =
  //     Number.isFinite(ltp) &&
  //     Number.isFinite(previousClose) &&
  //     previousClose > 0
  //       ? ((ltp - previousClose) / previousClose) * 100
  //       : 0;

  //   /*
  //    * Depending on how the Dhan response is stored, volume may use
  //    * one of these property names.
  //    */
  //   const volume = Number(
  //     quote?.volume ??
  //       quote?.total_traded_volume ??
  //       quote?.totalTradedVolume ??
  //       0,
  //   );

  //   return {
  //     ...item,

  //     ltp: Number.isFinite(ltp) ? ltp : null,
  //     ohlc: quote?.ohlc ?? {},
  //     intraday,

  //     percent_change: percentChange,

  //     volume: Number.isFinite(volume) ? volume : 0,

  //     quote_timestamp: snapshot?.quote_updated_at ?? null,
  //     smart_money,
  //   };
  // });
  // const finalData = useMemo(() => {
  //   if (!Array.isArray(watchlist)) return [];

  //   return watchlist.map((item) => {
  //     const marketSnapshot = item?.marketSnapshot;
  //     const technicalSnapshot = item?.technicalSnapshot;

  //     const quote = marketSnapshot?.quote?.data;
  //     const intraday = marketSnapshot?.intraday;

  //     const ltp = Number(quote?.last_price);
  //     const previousClose = Number(quote?.ohlc?.close);

  //     const percentChange =
  //       Number.isFinite(ltp) &&
  //       Number.isFinite(previousClose) &&
  //       previousClose > 0
  //         ? ((ltp - previousClose) / previousClose) * 100
  //         : 0;

  //     const volume = Number(
  //       quote?.volume ??
  //         quote?.total_traded_volume ??
  //         quote?.totalTradedVolume ??
  //         0,
  //     );

  //     const smartMoney =
  //       marketSnapshot?.smart_money ??
  //       intraday?.smart_money ??
  //       technicalSnapshot?.smart_money ??
  //       technicalSnapshot?.indicator_data?.smart_money ??
  //       null;

  //     return {
  //       ...item,

  //       marketSnapshot,
  //       technicalSnapshot,

  //       ltp: Number.isFinite(ltp) ? ltp : null,
  //       ohlc: quote?.ohlc ?? {},

  //       percent_change: percentChange,
  //       volume: Number.isFinite(volume) ? volume : 0,

  //       intraday,
  //       smart_money: smartMoney,

  //       quote_timestamp: marketSnapshot?.quote_updated_at ?? null,

  //       intraday_timestamp: marketSnapshot?.intraday_updated_at ?? null,

  //       eod_prediction:
  //         technicalSnapshot?.prediction ??
  //         technicalSnapshot?.prediction_result ??
  //         null,
  //     };
  //   });
  // }, [watchlist]);
  const getLiveVolume = (live) => {
    const rawVolume =
      live?.volume ??
      live?.totalVolume ??
      live?.totalTradedVolume ??
      live?.total_traded_volume;

    const volume = Number(rawVolume);

    return Number.isFinite(volume) && volume >= 0 ? volume : null;
  };
  const finalData = useMemo(() => {
    if (!Array.isArray(watchlist)) return [];

    return watchlist.map((item) => {
      const symbol = String(item?.symbol || "")
        .trim()
        .toUpperCase();

      const marketSnapshot = item?.marketSnapshot;
      const technicalSnapshot = item?.technicalSnapshot;

      const quote = marketSnapshot?.quote?.data;
      const intraday = marketSnapshot?.intraday;

      // WebSocket object for this stock
      const live = livePrices?.[symbol];

      /*
       * LTP:
       * 1. WebSocket
       * 2. market_snapshots quote
       */
      const liveLtp = Number(live?.ltp);
      const snapshotLtp = Number(quote?.last_price);

      const ltp = Number.isFinite(liveLtp)
        ? liveLtp
        : Number.isFinite(snapshotLtp)
          ? snapshotLtp
          : null;

      /*
       * Previous close normally comes from snapshot.
       * You can also use live previousClose if your WebSocket provides it.
       */
      const livePreviousClose = Number(live?.previousClose ?? live?.prevClose);

      const snapshotPreviousClose = Number(quote?.ohlc?.close);

      const previousClose = Number.isFinite(livePreviousClose)
        ? livePreviousClose
        : Number.isFinite(snapshotPreviousClose)
          ? snapshotPreviousClose
          : null;

      /*
       * Percentage change:
       * 1. WebSocket percentChange
       * 2. calculate using chosen LTP and previous close
       */
      const livePercentChange = Number(live?.percentChange);

      const calculatedPercentChange =
        Number.isFinite(ltp) &&
        Number.isFinite(previousClose) &&
        previousClose > 0
          ? ((ltp - previousClose) / previousClose) * 100
          : 0;

      const percentChange = Number.isFinite(livePercentChange)
        ? livePercentChange
        : calculatedPercentChange;

      /*
       * Volume:
       * 1. WebSocket cumulative volume
       * 2. market_snapshots quote volume
       */
      const liveVolume = getLiveVolume(live);

      const snapshotVolume = Number(
        quote?.volume ?? quote?.total_traded_volume ?? quote?.totalTradedVolume,
      );

      const volume =
        liveVolume !== null
          ? liveVolume
          : Number.isFinite(snapshotVolume)
            ? snapshotVolume
            : 0;

      /*
       * 20-day average supplied by backend
       */
      const averageVolume20 = Number(item?.volumeMetrics?.averageVolume20);

      /*
       * Relative volume uses live/fallback current volume.
       */
      const relativeVolume =
        Number.isFinite(volume) &&
        Number.isFinite(averageVolume20) &&
        averageVolume20 > 0
          ? volume / averageVolume20
          : null;

      /*
       * OHLC:
       * use live values when available, otherwise snapshot.
       */
      const ohlc = {
        open: Number.isFinite(Number(live?.open))
          ? Number(live.open)
          : quote?.ohlc?.open,

        high: Number.isFinite(Number(live?.high))
          ? Number(live.high)
          : quote?.ohlc?.high,

        low: Number.isFinite(Number(live?.low))
          ? Number(live.low)
          : quote?.ohlc?.low,

        close: previousClose,
      };

      const smartMoney =
        marketSnapshot?.smart_money ??
        intraday?.smart_money ??
        technicalSnapshot?.smart_money ??
        technicalSnapshot?.indicator_data?.smart_money ??
        null;

      return {
        ...item,

        symbol,

        marketSnapshot,
        technicalSnapshot,

        live,

        ltp,
        ohlc,

        percent_change: percentChange,

        volume,

        average_volume_20: Number.isFinite(averageVolume20)
          ? averageVolume20
          : null,

        relative_volume: relativeVolume,

        volume_days_used: item?.volumeMetrics?.historicalDaysUsed ?? 0,

        intraday,
        smart_money: smartMoney,

        quote_timestamp:
          live?.lastTradeTime ?? marketSnapshot?.quote_updated_at ?? null,

        intraday_timestamp: marketSnapshot?.intraday_updated_at ?? null,

        eod_prediction:
          technicalSnapshot?.prediction ??
          technicalSnapshot?.prediction_result ??
          null,

        isLiveValue: Boolean(live),
      };
    });
  }, [watchlist, livePrices]);
  console.log("Fional data", finalData);
  //filter
  const sortPercentHigh = () => {
    setPercentSort("high");
    setVolumeSort("none");
  };

  const sortPercentLow = () => {
    setPercentSort("low");
    setVolumeSort("none");
  };

  const sortVolumeHigh = () => {
    setVolumeSort("high");
    setPercentSort("none");
  };

  const sortVolumeLow = () => {
    setVolumeSort("low");
    setPercentSort("none");
  };
  const sortedFinalData = useMemo(() => {
    return [...finalData].sort((a, b) => {
      const percentA = Number(a?.percent_change) || 0;
      const percentB = Number(b?.percent_change) || 0;

      const volumeA = Number(a?.volume) || 0;
      const volumeB = Number(b?.volume) || 0;

      if (percentSort === "high") {
        return percentB - percentA;
      }

      if (percentSort === "low") {
        return percentA - percentB;
      }

      if (volumeSort === "high") {
        return volumeB - volumeA;
      }

      if (volumeSort === "low") {
        return volumeA - volumeB;
      }

      return 0;
    });
  }, [finalData, percentSort, volumeSort]);
  const formatVolume = (volume) => {
    const value = Number(volume);

    if (!Number.isFinite(value) || value <= 0) {
      return "-";
    }

    return value.toLocaleString("en-IN");
  };
  useEffect(() => {
    if (!watchlist?.length) return;

    const payload = watchlist.map((item) => ({
      symbol: item.symbol,
    }));

    fetchCombinedPredictions(payload);
  }, [watchlist]);
  console.log("COmbined prediction map", combinedPredictionMap);
  console.log("COmbined last updated", combinedLastUpdated);
  console.log("combined ", combinedIntradayUpdated);
  const datePart = combinedIntradayUpdated
    ? new Date(combinedIntradayUpdated).toLocaleDateString("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "";

  const timePart = combinedIntradayUpdated
    ? new Date(combinedIntradayUpdated).toLocaleTimeString("en-IN", {
        timeZone: "Asia/Kolkata",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      })
    : "";
  const getBgColor = (text) => {
    if (text === "Buy" || text === "Bullish" || text === "BUY") {
      return "#249966";
    } else if (text === "Sell" || text === "Bearish" || text === "SELL") {
      return "#dc2626";
    } else {
      return "#fbbf24";
    }
  };
  const notiyOptions = [
    { id: 1, option: "Email" },
    { id: 2, option: "Telegram" },
    { id: 3, option: "Whatsapp" },

    { id: 4, option: "Turn off" },
  ];
  useEffect(() => {
    const close = () => setActiveBell(null);

    window.addEventListener("click", close);
    return () => window.removeEventListener("click", close);
  }, []);
  // const latestQuoteTimestamp = finalData
  //   .map((item) => item.quote_timestamp)
  //   .filter(Boolean)
  //   .sort((a, b) => new Date(b) - new Date(a))[0];

  // const quoteDatePart = latestQuoteTimestamp
  //   ? new Date(latestQuoteTimestamp).toLocaleDateString("en-IN", {
  //       timeZone: "Asia/Kolkata",
  //       day: "2-digit",
  //       month: "short",
  //       year: "numeric",
  //     })
  //   : "";

  // const quoteTimePart = latestQuoteTimestamp
  //   ? new Date(latestQuoteTimestamp).toLocaleTimeString("en-IN", {
  //       timeZone: "Asia/Kolkata",
  //       hour: "2-digit",
  //       minute: "2-digit",
  //       second: "2-digit",
  //       hour12: true,
  //     })
  //   : "";
  //refrehs function
  // const loadMarketSnapshots = async () => {
  //   if (!watchlist?.length) {
  //     setSnapshotMap({});
  //     return;
  //   }

  //   try {
  //     setSnapshotLoading(true);

  //     const entries = await Promise.all(
  //       watchlist.map(async (item) => {
  //         const data = await getMarketSnapshot(item.symbol);
  //         return [item.symbol, data];
  //       }),
  //     );

  //     setSnapshotMap(Object.fromEntries(entries));
  //   } catch (err) {
  //     console.error("Market snapshot load failed:", err);
  //   } finally {
  //     setSnapshotLoading(false);
  //   }
  // };
  const handleRefresh = async () => {
    if (!userID) return;

    try {
      await fetchWatchlist(userID);
    } catch (err) {
      console.error("Watchlist refresh failed:", err);
    }
  };
  // console.log("quote data and time", quoteDatePart, quoteTimePart);

  const latestQuoteTimestamp = finalData.reduce((latest, item) => {
    const current = new Date(item?.quote_timestamp);

    return current > latest ? current : latest;
  }, new Date(0));

  const formatTimestamp = (dateValue) => {
    if (!dateValue) return "";

    const now = new Date(dateValue);

    if (isNaN(now)) return "";

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const month = monthNames[now.getMonth()];

    const year = now.getFullYear();

    const time = now.toLocaleTimeString("en-IN", {
      timeZone: "Asia/Kolkata",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    return `${day}-${month}-${year} | ${time}`;
  };

  const formattedQuoteTime = formatTimestamp(latestQuoteTimestamp);
  const getRelativeVolumeColor = (value) => {
    const relativeVolume = Number(value);

    if (!Number.isFinite(relativeVolume)) return "#6b7280";

    if (relativeVolume >= 1.5) return "#16a34a"; // green
    if (relativeVolume < 0.5) return "#9ca3af"; // grey

    return "#d97706"; // normal/orange
  };

  return (
    <>
      {/* <div className="back-btn">
        <button className="rec-btn" onClick={() => navigate(-1)}>
          Back
        </button>
      </div> */}

      <div style={{ padding: "20px" }}>
        <h2 className="watchlist-head">My Watchlist</h2>

        {/* ================= SEARCH ================= */}
        {/* <div
          className="search-option-input"
          style={{
            borderRadius: "12px",
            width: "50%",
            display: "flex",
            alignItems: "center",
            padding: "0px 10px",
            background: "white",

            margin: "10px auto",

            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
          }}
        >
          <input
            type="text"
            placeholder="Add to Watchlist"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="search-option-chain"
            style={{
              width: "100%",
              padding: "5px",
              outline: "none",
              border: "none",
            }}
          />

          {searchText && results?.length > 0 && (
            <div className="search-optionpage-dropdown">
              {results?.map((item) => {
                const added = isInWatchlist(item.symbol);

                return (
                  <div
                    key={item.id}
                    className="search-option-dropdown-item"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                    onClick={() =>
                      added ? handleRemove(item.symbol) : handleAdd(item.symbol)
                    }
                  >
                    <div>
                      <div className="dropdown-symbol">{item.symbol}</div>
                      <div className="dropdown-company">{item.company}</div>
                    </div>

                  </div>
                );
              })}
            </div>
          )}

          {searchLoading && <p>Searching...</p>}
        </div> */}
        <div
          className="search-option-input"
          style={{
            borderRadius: "12px",
            width: "50%",
            display: "flex",
            alignItems: "center",
            padding: "0px 10px",
            background: "white",
            margin: "10px auto",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
            position: "relative",
          }}
        >
          <input
            type="text"
            placeholder="Add to Watchlist"
            value={localSearch}
            onChange={(e) => setLocalSearch(e.target.value)}
            className="search-option-chain"
            autoComplete="off"
            style={{
              width: "100%",
              padding: "5px",
              outline: "none",
              border: "none",
            }}
          />

          {localSearch?.trim()?.length >= 2 &&
            filteredLocalStockResults.length > 0 && (
              <div className="search-optionpage-dropdown">
                {filteredLocalStockResults.map((item) => {
                  const symbol = String(
                    item?.symbol ||
                      item?.trading_symbol ||
                      item?.underlying_symbol ||
                      "",
                  )
                    .trim()
                    .toUpperCase();

                  const company =
                    item?.company ||
                    item?.display_name ||
                    item?.company_name ||
                    item?.name ||
                    "";

                  const added = isInWatchlist(symbol);

                  return (
                    <div
                      key={
                        item?.security_id ||
                        item?.securityId ||
                        item?.id ||
                        symbol
                      }
                      className="search-option-dropdown-item"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                      onClick={() =>
                        added ? handleRemove(symbol) : handleAdd(item)
                      }
                    >
                      <div>
                        <div className="dropdown-symbol">{symbol}</div>

                        <div className="dropdown-company">{company}</div>
                      </div>

                      <span>{added ? "Remove" : "Add"}</span>
                    </div>
                  );
                })}
              </div>
            )}

          {localSearchLoading && localSearch?.trim()?.length >= 2 && (
            <div className="search-optionpage-dropdown">
              <div className="search-option-dropdown-item">Searching...</div>
            </div>
          )}

          {!localSearchLoading &&
            localSearch?.trim()?.length >= 2 &&
            filteredLocalStockResults.length === 0 && (
              <div className="search-optionpage-dropdown">
                <div className="search-option-dropdown-item">
                  No stocks found
                </div>
              </div>
            )}
        </div>

        <div className="watchlist-disclaimer">
          <span className="watchlist-span">Note: </span>Add to Watchlist
          currently supports stocks from NIFTY 50, NIFTY BANK, NIFTY NEXT 50,
          NIFTY MIDCAP 100 and NIFTY IT INDEX only.
        </div>

        <div className="daily-trend-head">
          <div className="last-updated-head">
            <span>
              {/* As on {datePart} | {timePart} */}
              As on {formattedQuoteTime}
              {/* {lastUpdate} */}
            </span>

            <FiRefreshCw
              onClick={handleRefresh}
              size={18}
              style={{
                cursor: "pointer",
                transition: "0.2s",
              }}
              onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
              onMouseOut={(e) => (e.target.style.color = "#9ca3af")}
            />
          </div>
        </div>

        {/* ================= WATCHLIST TABLE ================= */}
        <div className="stock-table-container">
          <table className="stock-table watchlist-table">
            <thead>
              <tr>
                <th>Company</th>
                <th>LTP</th>
                <th>Close</th>
                {/* <th>%Change</th> */}
                <th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <span>% Change</span>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                    >
                      <FaChevronUp
                        size={10}
                        onClick={sortPercentHigh}
                        title="Highest % change first"
                      />

                      <FaChevronDown
                        size={10}
                        onClick={sortPercentLow}
                        title="Lowest % change first"
                      />
                    </div>
                  </div>
                </th>
                <th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <span>Volume</span>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                    >
                      <FaChevronUp
                        size={10}
                        onClick={sortVolumeHigh}
                        title="Highest volume first"
                      />

                      <FaChevronDown
                        size={10}
                        onClick={sortVolumeLow}
                        title="Lowest volume first"
                      />
                    </div>
                  </div>
                </th>

                <th>20D Avg Volume</th>
                <th>Relative Volume</th>
                <th>VWAP Trend</th>
                <th>UT Bot Signal</th>
                <th>BB Signal</th>
                <th>Smart Money</th>

                {/* <th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    RSI & MACD Trend
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                    ></div>
                  </div>

                  <span style={{ fontSize: "9px" }}>
                    (As of {combinedLastUpdated})
                  </span>
                </th> */}

                <th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    RSI & MACD Trend
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                    ></div>
                  </div>

                  {/* <span style={{ fontSize: "9px" }}>
                    {datePart} | {timePart}
                  </span> */}
                </th>
                {/* <th>Upside %</th> */}
                <th>Entry Price</th>
                <th>Exit Price</th>
                <th></th>
                <th></th>
                <th>Notify</th>
              </tr>
            </thead>

            <tbody>
              {sortedFinalData?.length === 0 ? (
                <tr>
                  <td colSpan="11" style={{ textAlign: "center" }}>
                    No stocks added
                  </td>
                </tr>
              ) : (
                sortedFinalData?.map((item) => (
                  <tr className="stock-row" key={item.id || item.symbol}>
                    {/* Company */}
                    <td
                      onClick={() =>
                        navigate(
                          `/stockdetail/${item?.symbol}/${item?.securityId}`,
                        )
                      }
                    >
                      {item?.symbol}
                    </td>

                    {/* LTP */}
                    <td>₹{item?.ltp}</td>

                    {/* Close */}
                    {/* <td>{item?.ohlc?.close ?? "-"}</td> */}
                    <td>₹{item?.ohlc?.close ?? "-"}</td>
                    {/* %Change */}
                    {/* <td
                      style={{
                        color:
                          combinedPredictionMap?.[
                            item?.symbol
                          ]?.hist_data?.close?.at(-1) && item?.ltp
                            ? (item.ltp -
                                combinedPredictionMap?.[
                                  item?.symbol
                                ]?.hist_data?.close?.at(-1)) /
                                combinedPredictionMap?.[
                                  item?.symbol
                                ]?.hist_data?.close?.at(-1)
                                > 0
                              ? "#16a34a"
                              : "#dc2626"
                            : "#6b7280",
                      }}
                    >
                      {combinedPredictionMap?.[
                        item?.symbol
                      ]?.hist_data?.close?.at(-1) && item?.ltp
                        ? (
                            ((item.ltp -
                              combinedPredictionMap?.[
                                item?.symbol
                              ]?.hist_data?.close?.at(-1)) /
                              combinedPredictionMap?.[
                                item?.symbol
                              ]?.hist_data?.close?.at(-1)) *
                            100
                          ).toFixed(2)
                        : "-"}
                      %
                    </td> */}
                    <td
                      style={{
                        color:
                          // combinedPredictionMap?.[
                          //   item?.symbol
                          // ]?.hist_data?.close?.at(-1) && item?.ltp
                          //   ? (item.ltp -
                          //       combinedPredictionMap?.[
                          //         item?.symbol
                          //       ]?.hist_data?.close?.at(-1)) /
                          //       combinedPredictionMap?.[
                          //         item?.symbol
                          //       ]?.hist_data?.close?.at(-1)
                          //       > 0
                          //     ? "#16a34a"
                          //     : "#dc2626"
                          //   : "#6b7280",
                          item?.percent_change > 0
                            ? "#249966"
                            : item?.percent_change < 0
                              ? "#f87171"
                              : "#64748b",
                      }}
                    >
                      {/* {combinedPredictionMap?.[
                        item?.symbol
                      ]?.hist_data?.close?.at(-1) && item?.ltp
                        ? (
                            ((item.ltp -
                              combinedPredictionMap?.[
                                item?.symbol
                              ]?.hist_data?.close?.at(-1)) /
                              combinedPredictionMap?.[
                                item?.symbol
                              ]?.hist_data?.close?.at(-1)) *
                            100
                          ).toFixed(2)
                        : "-"} */}
                      {item?.percent_change?.toFixed(2)}%
                    </td>

                    <td>{formatVolume(item?.volume)}</td>
                    <td>{formatVolume(item?.average_volume_20)}</td>

                    <td>
                      <span
                        style={{
                          color: getRelativeVolumeColor(item?.relative_volume),
                          fontWeight: "700",
                        }}
                      >
                        {Number.isFinite(Number(item?.relative_volume))
                          ? `${Number(item.relative_volume).toFixed(2)}x`
                          : "-"}
                      </span>
                    </td>
                    <td>
                      <button
                        className="rec-btn"
                        style={{
                          // background: getBgColor(
                          //   combinedPredictionMap?.[item?.symbol]
                          //     ?.vwapPrediction,
                          // ),
                          background: getBgColor(item?.intraday?.vwap_signal),
                        }}
                      >
                        {/* {combinedPredictionMap?.[item?.symbol]
                          ?.vwapPrediction ?? "-"} */}
                        {item?.intraday?.vwap_signal ?? "-"}
                      </button>
                    </td>
                    <td>
                      <button
                        className="rec-btn"
                        style={{
                          background: getBgColor(
                            // combinedPredictionMap?.[item?.symbol]?.utSignal,
                            item?.intraday?.ut_signal,
                          ),
                        }}
                      >
                        {/* {combinedPredictionMap?.[item?.symbol]?.utSignal ?? "-"} */}
                        {item?.intraday?.ut_signal ?? "-"}
                      </button>
                    </td>
                    <td>
                      <button
                        className="rec-btn"
                        style={{
                          background: getBgColor(
                            // combinedPredictionMap?.[item?.symbol]?.bbawe_signal,
                            item?.intraday?.bbawe_signal,
                          ),
                        }}
                      >
                        {/* {combinedPredictionMap?.[item?.symbol]?.bbawe_signal ??
                          "-"} */}
                        {item?.intraday?.bbawe_signal === "BUY"
                          ? "Bullish"
                          : item?.intraday?.bbawe_signal
                            ? "Bearish"
                            : "-"}
                      </button>
                    </td>
                    <td>
                      <button
                        className="rec-btn"
                        style={{
                          background: getBgColor(
                            // combinedPredictionMap?.[item?.symbol]?.bbawe_signal,
                            item?.smart_money?.signal,
                          ),
                        }}
                      >
                        {/* {combinedPredictionMap?.[item?.symbol]?.bbawe_signal ??
                          "-"} */}
                        {item?.smart_money?.signal ?? "-"}
                      </button>
                    </td>

                    {/* EOD */}
                    {/* <td>
                      <button
                        className="rec-btn"
                        style={{
                          background: getBgColor(
                            combinedPredictionMap?.[item?.symbol]
                              ?.batchPrediction,
                          ),
                        }}
                      >
                        {combinedPredictionMap?.[item?.symbol]
                          ?.batchPrediction ?? "-"}
                      </button>
                    </td> */}

                    {/* Live */}
                    <td>
                      <button
                        className="rec-btn"
                        style={{
                          background: getBgColor(
                            // combinedPredictionMap?.[item?.symbol]
                            //   ?.intradayPrediction,
                            item?.intraday?.prediction,
                          ),
                        }}
                      >
                        {/* {combinedPredictionMap?.[item?.symbol]
                          ?.intradayPrediction ?? "-"} */}
                        {item?.intraday?.prediction ?? "-"}
                      </button>
                    </td>

                    {/* Upside */}
                    {/* <td>
                      {editUpside[item.symbol] ? (
                        <div
                          style={{
                            display: "flex",
                            gap: "6px",
                            alignItems: "center",
                          }}
                        >
                          <input
                            type="number"
                            min="0"
                            max="100"
                            value={
                              tempUpside[item.symbol] ??
                              item.potentialUpside ??
                              0
                            }
                            onChange={(e) =>
                              setTempUpside((prev) => ({
                                ...prev,
                                [item.symbol]: e.target.value,
                              }))
                            }
                            style={{
                              width: "60px",
                              padding: "4px",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                            }}
                          />

                          <span>%</span>

                          <button
                            onClick={() => {
                              updatePotentialUpside({
                                userID,
                                symbol: item.symbol,
                                potentialUpside: Number(
                                  tempUpside[item.symbol] ?? 0,
                                ),
                              });

                              setEditUpside((prev) => ({
                                ...prev,
                                [item.symbol]: false,
                              }));
                            }}
                          >
                            Save
                          </button>
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            gap: "6px",
                            alignItems: "center",
                          }}
                        >
                          <span>{item.potentialUpside ?? 0}%</span>

                          <FaEdit
                            onClick={() =>
                              setEditUpside((prev) => ({
                                ...prev,
                                [item.symbol]: true,
                              }))
                            }
                          />
                        </div>
                      )}
                    </td> */}

                    {/* Entry */}
                    <td>
                      {editPrice[item.symbol]?.entry ? (
                        <div
                          style={{
                            display: "flex",
                            gap: "6px",
                            alignItems: "center",
                          }}
                        >
                          <input
                            type="text"
                            value={
                              tempPrice[item.symbol]?.entry ??
                              item.entryPrice ??
                              ""
                            }
                            onChange={(e) =>
                              setTempPrice((prev) => ({
                                ...prev,
                                [item.symbol]: {
                                  ...prev[item.symbol],
                                  entry: e.target.value,
                                },
                              }))
                            }
                            style={{ width: "70px" }}
                          />

                          <button
                            onClick={() => {
                              updatePrices({
                                userID,
                                symbol: item.symbol,
                                entryPrice:
                                  tempPrice[item.symbol]?.entry?.trim() ?? "",
                                exitPrice: item.exitPrice,
                              });

                              setEditPrice((prev) => ({
                                ...prev,
                                [item.symbol]: {
                                  ...prev[item.symbol],
                                  entry: false,
                                },
                              }));
                            }}
                          >
                            Save
                          </button>
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            gap: "6px",
                            alignItems: "center",
                          }}
                        >
                          <span>{item.entryPrice ?? "-"}</span>

                          <FaEdit
                            onClick={() =>
                              setEditPrice((prev) => ({
                                ...prev,
                                [item.symbol]: {
                                  ...prev[item.symbol],
                                  entry: true,
                                },
                              }))
                            }
                          />
                        </div>
                      )}
                    </td>

                    {/* Exit */}
                    <td>
                      {editPrice[item.symbol]?.exit ? (
                        <div
                          style={{
                            display: "flex",
                            gap: "6px",
                            alignItems: "center",
                          }}
                        >
                          <input
                            type="text"
                            value={
                              tempPrice[item.symbol]?.exit ??
                              item.exitPrice ??
                              ""
                            }
                            onChange={(e) =>
                              setTempPrice((prev) => ({
                                ...prev,
                                [item.symbol]: {
                                  ...prev[item.symbol],
                                  exit: e.target.value,
                                },
                              }))
                            }
                            style={{ width: "70px" }}
                          />

                          <button
                            onClick={() => {
                              updatePrices({
                                userID,
                                symbol: item.symbol,
                                entryPrice: item.entryPrice,
                                exitPrice:
                                  tempPrice[item.symbol]?.exit?.trim() ?? "",
                              });

                              setEditPrice((prev) => ({
                                ...prev,
                                [item.symbol]: {
                                  ...prev[item.symbol],
                                  exit: false,
                                },
                              }));
                            }}
                          >
                            Save
                          </button>
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            gap: "6px",
                            alignItems: "center",
                          }}
                        >
                          <span>{item.exitPrice ?? "-"}</span>

                          <FaEdit
                            onClick={() =>
                              setEditPrice((prev) => ({
                                ...prev,
                                [item.symbol]: {
                                  ...prev[item.symbol],
                                  exit: true,
                                },
                              }))
                            }
                          />
                        </div>
                      )}
                    </td>

                    {/* 🔔 Bell */}
                    {/* <td style={{ position: "relative" }}>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        
                        setActiveBell((prev) =>
                        
                          prev === item.symbol ? null : item.symbol,
                      );

                        console.log("Bell icon clicked!");
                      }}
                    >
                      {(item.isNotified ?? false) ? (
                        <FaBellSlash />
                      ) : (
                        <FaBell />
                      )}
                    </button>
                  </td> */}
                    <td style={{ position: "relative" }}>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();

                          // const newValue = !(item.isNotified ?? false);

                          // 🔥 CALL CONTEXT FUNCTION
                          toggleNotification({
                            userID,
                            symbol: item.symbol,
                            isNotified: !item.isNotified,
                          });

                          // optional UI state
                          setActiveBell((prev) =>
                            prev === item.symbol ? null : item.symbol,
                          );
                        }}
                      >
                        {item.isNotified ? <FaBell /> : <FaBellSlash />}
                      </button>
                    </td>

                    {/* 🗑 Delete */}
                    <td>
                      <button
                        className="sell-btn"
                        onClick={() => handleRemove(item.symbol)}
                      >
                        <RiDeleteBin7Line />
                      </button>
                    </td>
                    <td>
                      <select
                        style={{
                          width: "max-content",
                          padding: "5px",
                          borderRadius: "10px",
                          boxShadow: "rgba(0, 0, 0, 0.4) 0px 4px 12px",
                        }}
                        className="stocktest-inner-select"
                      >
                        {notiyOptions?.map((item) => (
                          <option
                            key={item.id}
                            disabled={item?.id !== 1}
                            style={{
                              color: item?.id !== 1 ? "#9ca3af" : "#000",
                            }}
                          >
                            {item.option}
                          </option>
                        ))}
                      </select>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default WatchList;
